// extracted by mini-css-extract-plugin
module.exports = {"button":"Lozenge_button__gAO_c","smallOnMobile":"Lozenge_smallOnMobile__rCchC","isActive":"Lozenge_isActive__QzOB4","reducedSize":"Lozenge_reducedSize___l4pf"};